import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad gäller för alkoholservering på festival eller utomhus?";
const SHORT_ANSWER = "Tillfälligt serveringstillstånd till allmänheten krävs. Ansök i god tid (8–12 veckor före), med ritning över serveringsyta, ordningshållning och åldersgrindar.";

export const Route = createFileRoute("/fraga/vad-galler-for-festival-och-utomhus")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad gäller för alkoholservering på festival ell…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Polis och räddningstjänst remitteras. Kommunen kräver normalt ordningsvakter, ID-kontroll vid entré och tydlig avgränsning av serveringsområdet."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsbank/serveringstillstand-festival", label: "Festival och utomhusservering – guide" }}
      related={[{"to": "/fraga/behover-mojligheten-kommunens-godkannande-i-forvag", "label": "Måste evenemangsplats godkännas i förväg?"}, {"to": "/fraga/hur-lange-far-tillfalligt-tillstand-vara", "label": "Hur länge kan ett tillfälligt serveringstillstånd gälla?"}, {"to": "/fraga/vad-galler-for-personal-utan-anstallningsavtal", "label": "Får jag använda personal utan anställningsavtal?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad gäller för alkoholservering på festival eller utomhus?" },
      { name: "description", content: "Tillfälligt serveringstillstånd till allmänheten krävs. Ansök i god tid (8–12 veckor före), med ritning över serveringsyta, ordningshållning och åldersgrindar." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-galler-for-festival-och-utomhus" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-galler-for-festival-och-utomhus" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-galler-for-festival-och-utomhus",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad gäller för alkoholservering på festival ell…", url: "https://alkoholprovet.se/fraga/vad-galler-for-festival-och-utomhus" },
      ]),
    ],
  }),
});
